var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoChassisRodas2Pt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "38px",
    viewBox: "0 0 28 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Picto Chassis e rodas &gt; 2pt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PICTOGRAMAS-CATEGORIES",
    transform: "translate(-203.000000, -399.000000)",
    stroke: "#00A9FD",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Picto-Chassis-e-rodas->-2pt",
    transform: "translate(204.000000, 400.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7897328,33.416157 C25.7897328,34.6911949 24.7530239,35.7247139 23.4740506,35.7247139 L21.7425457,35.7247139 C20.4635724,35.7247139 19.4268636,34.6911949 19.4268636,33.416157 L19.4268636,25.8183342 C19.4268636,24.5432962 20.4635724,23.5097772 21.7425457,23.5097772 L23.4740506,23.5097772 C24.7530239,23.5097772 25.7897328,24.5432962 25.7897328,25.8183342 L25.7897328,33.416157 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3628692,33.416157 C6.3628692,34.6911949 5.32616034,35.7247139 4.04718706,35.7247139 L2.31568214,35.7247139 C1.03670886,35.7247139 0,34.6911949 0,33.416157 L0,25.8183342 C0,24.5432962 1.03670886,23.5097772 2.31568214,23.5097772 L4.04718706,23.5097772 C5.32616034,23.5097772 6.3628692,24.5432962 6.3628692,25.8183342 L6.3628692,33.416157 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7897328,9.90633418 C25.7897328,11.1813722 24.7530239,12.2148911 23.4740506,12.2148911 L21.7425457,12.2148911 C20.4635724,12.2148911 19.4268636,11.1813722 19.4268636,9.90633418 L19.4268636,2.30851139 C19.4268636,1.03347342 20.4635724,-4.55696203e-05 21.7425457,-4.55696203e-05 L23.4740506,-4.55696203e-05 C24.7530239,-4.55696203e-05 25.7897328,1.03347342 25.7897328,2.30851139 L25.7897328,9.90633418 Z",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3628692,9.90633418 C6.3628692,11.1813722 5.32616034,12.2148911 4.04718706,12.2148911 L2.31568214,12.2148911 C1.03670886,12.2148911 0,11.1813722 0,9.90633418 L0,2.30851139 C0,1.03347342 1.03670886,-4.55696203e-05 2.31568214,-4.55696203e-05 L4.04718706,-4.55696203e-05 C5.32616034,-4.55696203e-05 6.3628692,1.03347342 6.3628692,2.30851139 L6.3628692,9.90633418 Z",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3628692,6.10742278 L10.3634318,6.10742278",
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8948664,8.63084051 L12.8948664,27.0938278",
    id: "Stroke-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4260724,29.6172 C15.4260724,31.010719 14.2929149,32.1408456 12.8946378,32.1408456 C11.4968179,32.1408456 10.3636603,31.010719 10.3636603,29.6172 C10.3636603,28.223681 11.4968179,27.0935544 12.8946378,27.0935544 C14.2929149,27.0935544 15.4260724,28.223681 15.4260724,29.6172 Z",
    id: "Stroke-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4260724,6.10742278 C15.4260724,7.50094177 14.2929149,8.63106835 12.8946378,8.63106835 C11.4968179,8.63106835 10.3636603,7.50094177 10.3636603,6.10742278 C10.3636603,4.7139038 11.4968179,3.58377722 12.8946378,3.58377722 C14.2929149,3.58377722 15.4260724,4.7139038 15.4260724,6.10742278 Z",
    id: "Stroke-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4260724,6.10742278 L19.426635,6.10742278",
    id: "Stroke-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3628692,29.6172 L10.3634318,29.6172",
    id: "Stroke-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4260724,29.6172 L19.426635,29.6172",
    id: "Stroke-21"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoChassisRodas2Pt);
export default __webpack_public_path__ + "static/media/PictoChassisRodas_2pt.241d85c94aad1f912a34d013fd9e41b7.svg";
export { ForwardRef as ReactComponent };